import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {TableReactiveUrlController} from "@amlCore/tableReactive";
import {Otkaz} from "../../model";
import {AccessJson, BounceFilter} from "@amlCore/models";
import {RegistriesService} from "../../service";
import {RegistriesAccessEnum} from "@amlCore/enums";
import {Utils} from "@amlCore/utils";
import {TableService, UserService, VisitedService} from "@amlCore/services";
import {IDataResponse} from "@amlCore/interfaces";


@Component({
  selector: 'app-registry-bounce-register-list',
  templateUrl: './bounceRegisterList.component.html'
})
export class BounceRegisterListComponent extends TableReactiveUrlController implements OnInit {

  isShowVisited = true;

  constructor(private regSrv: RegistriesService,
              private userSrv: UserService,
              protected activatedRoute: ActivatedRoute,
              protected visitedService: VisitedService,
              protected tableService: TableService,
              protected router: Router) {
    super(router, activatedRoute, visitedService, tableService, {sort: 'name', dir: 'ASC'});
  }

  public dataList: Otkaz[] = [];
  public isAll = true;
  public access: AccessJson;
  private id: string;
  goBack = Utils.goBack;
  ngOnInit() {
    this.access = this.userSrv.getAccess(RegistriesAccessEnum.QREF_OTKAZ);
    this.activatedRoute.params.subscribe(params => {
      this.id = params.id;
      this.activatedRoute.queryParams.subscribe((data: BounceFilter) => {
        this.isAll = !this.id;
        const paramsData = this.syncParams(data);
        paramsData.id = this.id;
        this.loadList(paramsData);
      });
    });
  }

  /**
   * метод получения объекта плоского фильтра
   * @param data объект фильтра с полями
   */
  public getFilterObject(data: BounceFilter) {
    const filter = this.tableService.getFilterSubject(data);
    return this.getFilterPlanObject(filter);
  }

  public onPageChange(params: BounceFilter) {
    const filter = this.getParams({...params, ...this.filter}) as BounceFilter;
    filter['isAll'] = this.isAll;
    this.navigate(filter);
  }

  public onSearch() {
    const params = this.getSearchPage(this.filter) as BounceFilter;
    this.onPageChange(params);
  }

  public edit(data: Otkaz) {
    this.router.navigate(['registries/bounceRegister', data.id]);
  }

  private loadList(params?: BounceFilter) {
    this.regSrv.getBounceRegisterList(this.getParams(params)).subscribe((data: IDataResponse<Otkaz>) => {
      this.initIdsMap(data);
      this.dataList = data.content;
      this.total = data.totalSize;
    });
  }
}
